import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDroppable } from '@dnd-kit/core';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
export const DroppableSeatContainer = ({ seatIndex }) => {
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    const { setNodeRef } = useDroppable({ id: seatIndex });
    const containerCss = useMemo(() => {
        if (!bounds) {
            return;
        }
        return css `
      position: absolute;
      pointer-events: none;
      width: ${bounds.w}px;
      min-width: ${bounds.w}px;
      height: ${bounds.h}px;
      min-height: ${bounds.h}px;
      left: ${bounds.x - bounds.w / 2}px;
      top: ${bounds.y - bounds.h / 2}px;
    `;
    }, [bounds]);
    if (!containerCss) {
        return null;
    }
    return _jsx("div", { ref: setNodeRef, css: containerCss });
};
